export type BooleanLikeFlag = boolean | number | string | null | undefined;

export const normalizeBooleanFlag = (flag: BooleanLikeFlag): 0 | 1 => {
  if (flag === null || flag === undefined) return 0;

  if (flag === true || flag === 1) return 1;
  if (flag === false || flag === 0) return 0;

  if (typeof flag === 'string') {
    const normalized = flag.trim().toLowerCase();
    if (normalized === '') return 0;
    if (normalized === 'true' || normalized === '1') return 1;
    if (normalized === 'false' || normalized === '0') return 0;
  }

  return 0;
};
